// src/components/ui/ModuloBloqueado.jsx
import React from "react";

export default function ModuloBloqueado({ modulo, detalhe, onLogout }) {
  return (
    <div style={{
      minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center",
      background:"linear-gradient(135deg,#1B3A6B 0%,#2563EB 100%)",
    }}>
      <div style={{
        background:"var(--bg-surface)", borderRadius:16, padding:"48px 40px",
        maxWidth:440, width:"90%", textAlign:"center",
        boxShadow:"0 20px 60px rgba(0,0,0,.3)"
      }}>
        <div style={{
          width:72, height:72, borderRadius:"50%",
          background:"#FEF3C7", display:"flex", alignItems:"center",
          justifyContent:"center", margin:"0 auto 20px"
        }}>
          <i className="bi bi-lock-fill" style={{fontSize:32, color:"#D97706"}}/>
        </div>

        <h4 style={{fontWeight:800, color:"var(--text-primary)", marginBottom:8}}>
          Módulo não disponível
        </h4>

        <p style={{color:"var(--gray-500)", fontSize:14, lineHeight:1.6, marginBottom:24}}>
          O módulo <strong style={{color:"#1B3A6B"}}>{modulo}</strong> não está
          incluído no plano atual do seu condomínio.
          <br/>Entre em contato com o administrador para liberar o acesso.
        </p>
        {detalhe && (
          <p style={{color:"var(--gray-600)", fontSize:13, lineHeight:1.5, marginTop:-12, marginBottom:24}}>
            {detalhe}
          </p>
        )}

        <div style={{
          background:"var(--bg-surface-alt)", borderRadius:10, padding:"14px 20px",
          marginBottom:24, fontSize:13, color:"var(--gray-600)", textAlign:"left"
        }}>
          <i className="bi bi-headset me-2" style={{color:"#2563EB"}}/>
          <strong>Fale com seu gestor</strong>
          <br/>
          <span style={{fontSize:12, color:"var(--gray-400)"}}>
            Solicite a ativação do módulo através do administrador do sistema.
          </span>
        </div>

        <button
          onClick={onLogout}
          className="btn btn-outline-secondary w-100"
          style={{fontSize:14}}>
          <i className="bi bi-box-arrow-left me-2"/>Sair do sistema
        </button>
      </div>
    </div>
  );
}
